import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Store } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';
import { STORES_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-store-data-table',
  templateUrl: './company-details-store-data-table.component.html',
  styleUrls: ['./company-details-store-data-table.component.scss'],
})
export class CompanyDetailsStoreDataTableComponent {
  @Input() stores: Store[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = STORES_TABLE_COLUMNS;

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  onDetailsClick(store: Store): void {
    this.navigation_service.toStoreDetails(store.company_id as string, store.store_id as string);
  }

  getStoreStatusBackgroundClass(store?: Store): { [key: string]: boolean | undefined } {
    if (!store) return {};
    return this.utils_service.getStoreStatusBackgroundClass(store);
  }

  getStoreStatusLabel(store?: Store): string {
    if (!store) return '';
    return this.utils_service.getStoreStatusLabel(store);
  }

  getStoreTypeLabel(store?: Store): string {
    const is_web_sale = store?.order_requirements?.is_web_sale_enabled;
    const is_in_store_sale = store?.order_requirements?.is_in_store_sale_enabled;

    if (is_web_sale && is_in_store_sale) {
      return 'STORES.PHYSICAL_STORES_AND_ECOMMERCE';
    }
    if (is_web_sale) {
      return 'STORES.ECOMMERCE_ONLY';
    }
    if (is_in_store_sale) {
      return 'STORES.PHYSICAL_STORE_ONLY';
    }

    return '-';
  }

  isSalesNetworkIDEditable(store: Store): boolean {
    return !store.is_sales_network_id_editing_disabled;
  }
}
